/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ConnectLarkCreate = lazyLoad(
  () => import('./index'),
  module => module.ConnectLarkCreate
);
